module.exports = __webpack_public_path__ + "b64867fe62b590ee8876cf393f8b5175.pdf";